<template>
  <div>
    <p>Add a existing user to this supplier, or <a href="#" @click.prevent="invite = !invite">Invite a new user</a></p>
    <div v-if="invite === false">
      <validation-observer v-slot="{ invalid }" class="pt-3">
        <form @submit.prevent="submitUser">
          <validation-provider v-if="!connection" name="Find Users" v-slot="context" rules="required">
            <b-form-group label="User">
              <multi-select
                v-model="user"
                :options="users"
                placeholder="Pick a user"
                label="email"
                @open="findUser"
                @search-change="findUser"
              />

              <b-form-invalid-feedback v-bind="context.ariaMsg">
                {{ context.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <template v-else>
            <b-form-checkbox-group v-model="selectedPermissions" :options="permissions" stacked />
          </template>

          <hr />
          <b-row align-h="end">
            <b-col cols="auto">
              <b-button variant="primary" :disabled="invalid" type="submit">
                {{ !connection ? 'Add User' : 'Sync Permissions' }}
              </b-button>
            </b-col>
          </b-row>
        </form>
      </validation-observer>
    </div>
    <div v-else>
      <b-form-group label="Invite Supplier Email">
        <b-input v-model="inviteEmail" />
      </b-form-group>
      <b-button @click="inviteUser()">Invite</b-button>
    </div>
  </div>
</template>

<script>
import 'vue-multiselect/dist/vue-multiselect.min.css'

import { users as usersApi, suppliers as suppliersApi, roles as roleApi } from '@youwish1/api-package'
import { getValidationState } from './page-helpers'
import MultiSelect from 'vue-multiselect'

export default {
  name: 'SupplierUsersForm',
  components: { MultiSelect },
  props: { connection: { type: Object } },
  data() {
    return { user: '', users: [], permissions: [], selectedPermissions: [], invite: false, inviteEmail: '' }
  },
  async mounted() {
    if (this.connection) {
      const roles = await roleApi.all()
      this.permissions = roles.data
        .find(role => role.name === 'Supplier')
        .permissions.map(permission => ({ value: permission.id, text: permission.name }))
      this.selectedPermissions = this.connection.user.permissions.map(permission => {
        return this.permissions.find(p => p.text === permission).value
      })
    }
  },
  methods: {
    getValidationState,
    submitUser() {
      if (this.connection) {
        this.syncUserPermissions()
      } else {
        this.inviteEmail = this.user.email
        this.inviteUser()
      }
    },
    async addUserToSupplier() {
      await suppliersApi.users().add(this.$route.params.id, this.user.id)
      this.$emit('added')
    },
    async syncUserPermissions() {
      const permissions = usersApi.permissions(this.connection.user.id)
      await permissions.sync({ data: this.selectedPermissions })
      this.$emit('updated')
    },
    async inviteUser() {
      await suppliersApi.invite(this.$route.params.id, { email: this.inviteEmail })
      this.$emit('added')
    },
    async findUser(email = '') {
      const users = await usersApi.all({ filter: { email } })

      this.users = users.data()
    },
  },
}
</script>
